import React,
{
    useState
}
from "react";

import {
    updateLink
}
from "../services/shortLinkService";

export default function EditLinkModal({
    currentUser,
    link,
    onClose,
    refresh
}) {

    const [title,
           setTitle] =
        useState(
            link.title || ""
        );

    const [destinationUrl,
           setDestinationUrl] =
        useState(
            link.destinationUrl || ""
        );

    const [active,
           setActive] =
        useState(
            link.active !== false
        );

    const [expiresAt,
           setExpiresAt] =
        useState(
            link.expiresAt || ""
        );

    const [saving,
           setSaving] =
        useState(false);

    async function handleSave() {

        try {

            setSaving(true);

            await updateLink(
                currentUser,
                link.shortCode,
                {
                    title,
                    destinationUrl,
                    active,
                    expiresAt:
                        expiresAt || null
                }
            );

            await refresh();

            onClose();

        }

        catch (error) {

            console.error(error);

            alert(
                "Unable to update link."
            );

        }

        finally {

            setSaving(false);

        }

    }

    return (

        <div
            className="modalOverlay"
            onClick={onClose}
        >

            <div
                className="modalCard"
                onClick={e =>
                    e.stopPropagation()
                }
            >

                <div className="modalHeader">

                    <h2>
                        Edit Link
                    </h2>

                    <button
                        className="closeButton"
                        onClick={onClose}
                    >
                        ×
                    </button>

                </div>

                <div className="formGroup">

                    <label>
                        Short Code
                    </label>

                    <input
                        value={
                            link.shortCode
                        }
                        disabled
                    />

                </div>

                <div className="formGroup">

                    <label>
                        Title
                    </label>

                    <input
                        value={title}
                        onChange={e =>
                            setTitle(
                                e.target.value
                            )
                        }
                    />

                </div>

                <div className="formGroup">

                    <label>
                        Destination URL
                    </label>

                    <input
                        value={
                            destinationUrl
                        }
                        onChange={e =>
                            setDestinationUrl(
                                e.target.value
                            )
                        }
                    />

                </div>

                <div className="checkboxGroup">

                    <input
                        type="checkbox"
                        checked={active}
                        onChange={e =>
                            setActive(
                                e.target.checked
                            )
                        }
                    />

                    <label>
                        Active
                    </label>

                </div>

                <div className="formGroup">

                    <label>
                        Expiration Date
                    </label>

                    <input
                        type="datetime-local"
                        value={expiresAt}
                        onChange={e =>
                            setExpiresAt(
                                e.target.value
                            )
                        }
                    />

                </div>

                <div className="modalActions">

                    <button
                        onClick={onClose}
                    >
                        Cancel
                    </button>

                    <button
                        className="primaryButton"
                        disabled={saving}
                        onClick={
                            handleSave
                        }
                    >

                        {
                            saving
                                ? "Saving..."
                                : "Save Changes"
                        }

                    </button>

                </div>

            </div>

        </div>

    );

}